import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'app-manual-configuration',
  templateUrl: './manual-configuration.page.html',
  styleUrls: ['./manual-configuration.page.scss'],
})
export class ManualConfigurationPage implements OnInit {


  @Input() public activeconfiguration: any;

  public appPages = [
    {
      title: "Search",
      url: "/configuration-data",
      icon: "mail",
      action: 1,
    },
    {
      title: "Data Detail",
      url: "/configuration-detail",
      icon: "paper-plane",
      action: 2,
    }
  ];

  constructor(public router: Router, public appService: AppService) {}

  ngOnInit() {
    // this.appService.active.subscribe((value) => {
    //   console.log("value...", value);
    //   this.activecustomer = value;
    // });
  }

  ionViewDidEnter(){
    this.appService.active.subscribe((value) => {
      console.log("value...", value);
      this.activeconfiguration = value;
    });
  }

  clickMenu(a) {
    this.appService.setActive(a);
    this.router.navigate([a.url]);

    // if (a.action === 1) {
    //   this.appService.setActive(a);
    //   this.router.navigate([a.url]);
    // }
    // if (a.action === 2) {
    //   this.appService.setActive(a);
    //   this.router.navigate([a.url]);
    // }
  }

}
